<script>
    import Module from "./Module.svelte";

    export let modules;
    export let manager;
    export let targetId;
    export let languages;
</script>

<div class="semester">
    <div class="modules columns">
        {#each modules as module}
            <Module languages={languages} on:cardClick subjects={module} manager={manager} targetId={targetId}/>
        {/each}
    </div>
</div>

<style>
    .semester{
        margin: 10px 0 10px 0;
        padding: 10px 5px 10px 5px;
        background-color: rgba(241, 239, 239, 0.1);
        border-top: 1px solid rgba(248, 246, 246, 0.4);
        border-radius: 3px;
    }
</style>